module.exports = __webpack_public_path__ + "static/media/default_wrench_icon.7d878216.svg";